import { Component, OnInit, ViewChild, OnDestroy, NgZone, HostListener, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray, FormArray, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { DatePipe, Location } from '@angular/common';
import { ProductService } from 'src/app/services/product.service';
import { Product, ProductEntityMediaGallery, CatalogInventoryStockItem, CatalogCategoryProduct } from 'src/app/models/product';
import { Constant } from 'src/app/constant/constant';
import { CategoryService } from 'src/app/services/category.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FieldConfig } from 'src/app/shared/dynamic-form/field-interface';
import { CalsoftAuditComponent } from 'src/app/pages/audit/audit.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { conditionalValidator, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, takeUntil } from 'rxjs/operators';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { environment } from 'src/environments/environment';
import { ConfigurableProductComponent } from '../../configurable-product/configurable-product.component';
import { ProductLinkComponent } from '../product-link/product-link.component';
import { ConfigService } from 'src/app/services/config.service';
import { COMMA, ENTER, I, T } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { TextEditorComponent } from 'src/app/shared/text-editor/text-editor.component';
import { ProductlistingService } from 'src/app/services/productlisting.service';
import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';


@UntilDestroy()
@Component({
  selector: 'calsoft-add-edit-product',
  templateUrl: './add-edit-product.component.html',
  styleUrls: ['./add-edit-product.component.scss'],
  animations: [...ROUTE_TRANSITION],

  host: { '[@routeTransition]': '' },

})
export class AddEditProductComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';

  protected _onDestroy = new Subject<void>();
  b2bPricingEnabled: any = false;
  row: any;
  productId: any;
  visible: boolean;
  productadd: any;
  description: boolean;
  attributeSetIdList: Object;
  defaultValue: any;
  defalutValue: any;
  group: UntypedFormGroup;
  attributeGroup: any;
  groupName: any;
  selection: any = [];
  entityValue: any;
  activeGroup: string;
  activeType: string;
  showOnlyStarred: boolean;
  text: any;
  activeGroupSubscription: Subscription;
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();
  public serverPath8 = environment.commonImageApi;

  clickListeners: Function[] = [];

  respondActive: boolean;


  regConfig: FieldConfig[]

  selectedIndex = 0;
  lastIndex = 3;
  operationType: string;
  title: string;
  attributeSetList: any;


  //new
  drawerOpen = true;
  drawerMode = 'side';
  drawerDisableClose = true;
  form: UntypedFormGroup;
  invalidMap = new Map<any, any>();
  ValidMap = new Map<any, any>();
  fieldValue: any[];
  series: any = [];
  validations: any = [];
  valueId: any;
  empty: string;
  list: any;
  productEntity: any;
  catalogProductEntityVarchar: any = [];
  catalogProductEntityInt: any = [];
  catalogProductEntityText: any = [];
  catalogProductEntityDecimal: any = [];
  catalogProductEntityStatic: any = [];
  catalogProductEntityDatetime: any = [];
  imagesToRemoved: any = [];
  mediaGallery: any = [];
  textAdd: string;
  auditData: Object;
  auditType: any;
  filteredAttributeList: any;
  filteredAttributeTypeList: any;
  options: any;
  sameProductName: boolean;
  visibleConfig: boolean = false;
  initalValue: any;
  skuInitalValue: any;
  productConfigurable: boolean;
  relatedProductList: any = [];

  productSuperLinkList: any = [];
  upSellsProductList: any = [];
  crossSellsProductList: any = [];
  productLinkList: any = [];
  relatedProducts: any = [];
  upSellsProduct: any = [];
  crossSellsProduct: any = [];
  productData: any;
  updateStockByPurchaseOnly: any = false;
  variants1: any = [];
  variants2: any = [];
  variantsList: any = [];

  subscriptionOccurrencesList: any = [];

  courseItemList: any = [];

  productVariant: boolean = false;

  productCourse: boolean = false;

  currentIndex: any;
  data: Object;
  initalSelectionList: any = [];
  bookingEnabled: boolean = false;
  productRestriction: boolean = false;
  courseList: any = [];


  courseForm: FormGroup;
  courseIndex: any = 0;
  courseId: any = 0;
  courseItemId: any = 0;
  primaryIndex: any = 0;
  secondaryIndex: any = 0;
  courseType: string = 'Add';
  cid: any;
  setId: any;



  previousPage() {
    this.selectedIndex -= 1;
  }

  nextPage() {
    this.selectedIndex += 1;
  }
  firstFormGroup: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private ecryptService: EcryptServiceService,
    public loc: Location,
    private route: ActivatedRoute,
    private attributeService: AttributesetService,
    private productService: ProductService,
    private categoryService: CategoryService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private screenSizeService: ScreenSizeService,
    private mediaMatcher: MediaMatcher,
    private zone: NgZone,
    private datepipe: DatePipe,
    private configService: ConfigService,
    private _formBuilder: FormBuilder,
    private productlistingService: ProductlistingService,
    private dynamicFormGroupService: DynamicFormGroupService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
  drawerOpen$ = this.screenSizeService.drawerOpen$;
  public serverPath = environment.ImageAPI;
  public serverPath1 = environment.ImageAPI1;
  public serverPath2 = environment.thumnail;
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath3 = environment.ImageAPI2

  public serverPath4 = environment.commonImageApiNew

  productType: any = [
    "Simple", "Configurable", "Variants", "Booking", "Subscription", "Course", "Variants Subscription", "Services"
  ]

  productType1: any = [
    "Simple"
  ]


  createAttributeForm() {
    this.firstFormGroup = this.formBuilder.group({
      attributeSet: ['', Validators.required],
      type: ['', [Validators.required]],
    });
  }



  createAttributeValidations = {
    'attributeSet': [
      { type: 'required', message: 'Please fill out this field.' },
    ],
    'type': [
      { type: 'required', message: 'Please fill out this field.' },
    ],

  }

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    this._onDestroy.next();
    this._onDestroy.complete();
  }



  ngOnInit() {

    let value = localStorage.getItem(Constant.enterPriseKey);

    if (value != null) {

      this.cid = "&cid=" + value
    }

    this.getResource();
    this.createCourseForm();
    this.textAccount = 'OK';
    if (this.router.url.includes("/config/")) {
      this.productConfigurable = true;
    } else {
      this.productConfigurable = false;
    }

    if (this.router.url.includes("/variant/")) {

      this.productVariant = true;
    }

    else if (this.router.url.includes("/variantSubscription/")) {

      this.productVariant = true;
    } else {
      this.productVariant = false;
    }



    if (this.router.url.includes("/duplicateproduct")) {
      this.productId = 0;

    } else {

      this.productId = this.route.snapshot.params['productId'];
    }

    this.createAttributeForm();
    this.attributeSetFilter();

    this.getdynamicForm();


  }

  relatedSell: boolean = false;
  crossSell: boolean = false;
  upSell: boolean = false;
  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.PRODUCT)
      .subscribe((data: any) => {



        if ((this.productId == 0 && !data.create) || (this.productId != 0 && !data.update)) {

          this.router.navigate(['/unauthorized'])
        } else {
          if (data.restriction.length > 0) {
            this.relatedSell = data.restriction[0].relatedSell == 1 ? true : false;
            this.crossSell = data.restriction[0].crossSell == 1 ? true : false;
            this.upSell = data.restriction[0].upSell == 1 ? true : false;
            this.productLimitedRestrictionValue = data.restriction[0].productLimitedRestriction;
            this.productLimitedRestriction = true;
          } else {
            this.productLimitedRestriction = false;
          }

          this.defalutValue = 0;

          this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
          this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
          };
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            filter(() => this.mobileQuery.matches),
            untilDestroyed(this)
          ).subscribe(() => this.closeDrawer());

          this.visible = false;
          this.text = "Save";
          this.textAdd = "Create"

          this.getConfigData();

          this.setId = this.route.snapshot.params['setId'];


          if (this.router.url.includes("/approval")) {
            this.productadd = true;
            this.title = 'Add Products'
            this.firstFormGroup.value.type = this.route.snapshot.params['type'];
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.operationType = 'Change'
            this.getAttributeGroup();


          }
          else if (this.router.url.includes("/duplicateproduct")) {
            this.productadd = true;
            this.title = 'Add Products'
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.operationType = 'Change'
            this.getAttributeGroup();
          }

          else if (this.productId == 0 && this.setId != undefined) {
            this.productadd = true;
            this.title = 'Add Products'
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.setId;
            this.operationType = 'Change'
            this.getAttributeGroup();
          }



          else if (this.productId == 0) {
            // this.createAttributeForm();
            this.operationType = 'New'
            this.title = 'Add Products'
            this.getAttributeSetDropDown();
          }

          else if (this.productId > 0) {
            this.title = 'Edit Products'
            // this.createAttributeForm();
            this.firstFormGroup.value.type = "ss";
            this.firstFormGroup.value.attributeSet = this.route.snapshot.params['setId'];
            this.operationType = 'Change'
            this.getAttributeGroup();
          }

          if (data.restriction.length > 0) {
            this.productRestriction = data.restriction[0].productRestriction == 1 ? true : false;
          }
          if (this.productRestriction) {
            this.productType1
          } else {
            this.productType
          }

        }
      })
  }




  audit(i) {

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        width: '900px',
        disableClose: true,
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  catalogProductSuperAttributeList: any = [];

  catalogProductSuperLinkList: any = [];
  getConfig() {

    this.catalogProductSuperLinkList = [];
    this.catalogProductSuperAttributeList = [];
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(ConfigurableProductComponent, {
        disableClose: true,
        width: '1000px',
        data: { productId: this.productId, setId: this.firstFormGroup.value.attributeSet }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {
          //this.assignedAttributeId = result.assiginedAttributeId;

          this.catalogProductSuperAttributeList = result.data['catalogProductSuperAttribute']

          this.catalogProductSuperLinkList = result.data['catalogProductSuperLink']
          this.form.value.catalogProductSuperAttribute = result.data['catalogProductSuperAttribute']
          this.form.value.catalogProductSuperLink = result.data['catalogProductSuperLink']
          this.form.patchValue(this.form.value);
          //this.removedFilterAttributeIdList = result.removedFilterAttributeIdList;
        }

      });
    }
    else {
      let dialogRef = this.dialog.open(ConfigurableProductComponent, {
        disableClose: true,
        minWidth: '100vw', height: '100vh',
        data: { productId: this.productId, setId: this.firstFormGroup.value.attributeSet }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

        if (result['event'] == 'add') {
          //this.assignedAttributeId = result.assiginedAttributeId;

          this.catalogProductSuperAttributeList = result.data['catalogProductSuperAttribute']

          this.catalogProductSuperLinkList = result.data['catalogProductSuperLink']
          this.form.value.catalogProductSuperAttribute = result.data['catalogProductSuperAttribute']
          this.form.value.catalogProductSuperLink = result.data['catalogProductSuperLink']
          this.form.patchValue(this.form.value);
          //this.removedFilterAttributeIdList = result.removedFilterAttributeIdList;
        }

      });
    }
  }


  back() {
    this.loc.back();
  }




  getAttributeGroup() {

    if ((this.text == 'Save' || this.textAdd == 'Create') && this.firstFormGroup.valid || this.operationType == 'Change') {
      this.textAdd = "Processing"
      this.entityValue = {
        "typeId": this.firstFormGroup.value.type,
        "attributeSetId": this.firstFormGroup.value.attributeSet,

      }
      this.attributeService.getattributeSetId(this.firstFormGroup.value.attributeSet).subscribe(
        attributesets => {

          this.attributeSetIdList = attributesets['data']
          this.attributeGroup = attributesets['data']['eavAttributeGroup']

          this.productadd = true;
          this.regConfig = this.attributeSetIdList['eavAttributeGroup']
          this.groupName = this.regConfig[this.defalutValue]['attributeGroupName']
          this.form = this.createControl();


          if (this.form.value.varientProductItems.length != 0) {
            if (this.form.value.varientProductItems[0].varientId == '') {

              const formArray = this.form.get('varientProductItems') as FormArray;
              formArray.removeAt(0);

            }

          }

          let index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Recurring Profile')
          if (index >= 0) {
            this.regConfig.splice(index, 1);
          }

          index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Design')
          if (index >= 0) {
            this.regConfig.splice(index, 1);
          }

          index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Gift Options')
          if (index >= 0) {
            this.regConfig.splice(index, 1);
          }
          //related

          let imageIndex = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Images')
          if (imageIndex == -1) {
            this.attributeGroup.push({
              attributeGroupId: 0,
              attributeGroupName: "Images",
              defaultId: 0,
              sort: false
            })
          }





          this.attributeGroup.push({
            attributeGroupId: 0,
            attributeGroupName: "Inventory",
            defaultId: 0,
            sort: false
          })
          this.attributeGroup.push({
            attributeGroupId: 0,
            attributeGroupName: "Categories",
            defaultId: 0,
            sort: false
          })



          this.attributeGroup.push({
            attributeGroupId: 0,
            attributeGroupName: "Related Products",
            defaultId: 0,
            sort: false
          })
          this.attributeGroup.push({
            attributeGroupId: 0,
            attributeGroupName: "Up-Sells",
            defaultId: 0,
            sort: false
          })

          this.attributeGroup.push({
            attributeGroupId: 0,
            attributeGroupName: "Cross-Sells",
            defaultId: 0,
            sort: false
          })

          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Variants") {
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Variants",
                defaultId: 0,
                sort: false
              })

            }
          }

          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Booking") {
              this.bookingEnabled = true;
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Booking",
                defaultId: 0,
                sort: false
              })





              let index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Inventory')
              if (index >= 0) {
                this.regConfig.splice(index, 1);
              }
            }
          }

          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Services") {
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Services",
                defaultId: 0,
                sort: false
              })

              let index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Inventory')
              if (index >= 0) {
                this.regConfig.splice(index, 1);
              }
            }
          }

          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Course" || this.firstFormGroup.value.type == "Variants Subscription") {
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Course",
                defaultId: 0,
                sort: false
              })

            }
          }

          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Variants Subscription") {
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Variants Subscription",
                defaultId: 0,
                sort: false
              })

            }
          }


          if (this.productId == 0) {
            if (this.firstFormGroup.value.type == "Subscription") {
              this.attributeGroup.push({
                attributeGroupId: 0,
                attributeGroupName: "Subscription",
                defaultId: 0,
                sort: false
              })

            }
          }


          if (this.router.url.includes("/duplicateproduct")) {
            this.getProductById(this.route.snapshot.params['productId']);
          }
          else if (this.router.url.includes("/approval/")) {
            this.getLeadById(this.route.snapshot.params['listingId'])
          }

          else if (this.productId > 0) {
            this.getProductById(this.productId);
          }
          this.getCategory();
          this.textAdd = "Create";
        },
        error => {
          this.textAdd = "Create";
        }
      )
    }
    else {
      this.textAdd = "Create";
      this.validateAllFormFields(this.firstFormGroup)
    }

  }




  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  get(i, j, k) {

    this.defalutValue = '';
    this.groupName = i;
    this.defalutValue = j;
    if (i != "catalogInventoryStockItem" && i != "Categories") {
      this.group = this.defalutValue;

      this.regConfig = this.attributeSetIdList['eavAttributeGroup']

    }
    if (i == "Categories" && this.form.value.catalogCategoryProduct[0].categoryId > 2 && this.productId == 0) {
      this.selection = []
      this.form.value.catalogCategoryProduct.forEach(element => {
        this.selection.push(element.categoryId)
      });
    }
    this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
    this.scrollToBottom();


  }


  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  subscriptionType: any = [
    { "value": 1, "viewValue": "Month" },
    { "value": 2, "viewValue": "Year" },
  ]

  renewalType: any = [
    { "value": 1, "viewValue": "Every" },
    { "value": 2, "viewValue": "Every 2nd" },
    { "value": 3, "viewValue": "Every 3nd" },
    { "value": 4, "viewValue": "Every 4th" },
    { "value": 5, "viewValue": "Every 5th" },
    { "value": 6, "viewValue": "Every 6th" },
  ]


  submit(value: any) {

  }


  getAttributeSetDropDown() {
    this.attributeService.getAttributeSetDropDownList(4).subscribe(
      res => {
        this.attributeSetList = res;

        const encryptedData = localStorage.getItem('configSettingsData');
        if (encryptedData) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedData);
            const data = JSON.parse(decrypted);

            if (data != null) {

              this.firstFormGroup.value.attributeSet = parseInt(data['defaultProductSet']);



            } else {
              this.firstFormGroup.value.attributeSet = parseInt(this.attributeSetList[0].attributeSetId)
            }
            this.firstFormGroup.value.type = "Simple";
            this.firstFormGroup.patchValue(this.firstFormGroup.value)


          } catch (error) {
            console.error("Failed to decrypt crmSettingsData:", error);
          }

        }

        this.filteredAttributeList = this.attributeSetList;

      },
      error => {

      }
    )
  }





  //create controls
  createControl() {
    let group;
    group = this.formBuilder.group({});
    group.addControl('catalogInventoryStockStatus', this.formBuilder.group({
      websiteId: new UntypedFormControl(1),
      stockId: new UntypedFormControl(1),
      stockStatus: ['',],
      qty: ['',],
      productId: ['']
    }));
    group.addControl('productEntityMediaGallery', this.formBuilder.array([
      this.productEntityMediaGallery()
    ])
    );
    group.addControl('catalogCategoryProduct', this.formBuilder.array([
      this.addControlsToCatalogCategoryProduct()
    ]));
    group.addControl('catalogProductLink', this.formBuilder.array([
      this.addControlsToCatalogProductLink()
    ]));


    group.addControl('varientProductItems', this.formBuilder.array([

      this.varientproductformItem()
    ]));



    group.addControl('slots', this.formBuilder.array([

    ]));


    group.setControl('slots', this.initTimeSlot(0));

    group.addControl('variant', this.formBuilder.group({
      variantId: new UntypedFormControl(0),
      variantLabel1: ['', []],
      variantLabel2: ['', []],
      variantLabel3: ['', []],
      variantLabel4: ['', []],
      variantLabel5: ['', []],
      variantType1: new FormControl("1"),
      variantType2: new FormControl("1"),
      variantType3: ['', []],
      variantType4: ['', []],
      variantType5: ['', []],
      maintainStockInd: new FormControl(0),
      maintainPriceInd: new FormControl(0),
      maintainImageInd: new FormControl(0),
      variantLabel1Filter: new FormControl(1),
      variantLabel2Filter: new FormControl(1),
      variantLabel3Filter: new FormControl(1),
      variantLabel4Filter: new FormControl(1),
      variantLabel5Filter: new FormControl(1),


    }));



    group.addControl('course', this.formBuilder.array([


    ]));






    group.addControl('catalogInventoryStockItem', this.formBuilder.group({
      manageStock: new UntypedFormControl({ value: 1, disabled: false }),
      qty: [1, [Validators.required]],
      stockId: new UntypedFormControl(1),
      itemId: ['',],
      //   qtyOutOfStock: new FormControl({ value: '0', disabled: true }),
      minQty: new UntypedFormControl(0),
      minSaleQty: [0, [Validators.required]],
      maxQty: [0, [Validators.required]],
      isQtyDecimal: new UntypedFormControl(1),
      notifyStockQty: [1, [Validators.required]],
      enableQtyIncrements: new UntypedFormControl(0),
      isInStock: new UntypedFormControl(1),

    }));

    group.addControl('catalogInventoryStockItem', this.formBuilder.group({
      manageStock: new UntypedFormControl({ value: 1, disabled: false }),
      qty: [1, [Validators.required]],
      stockId: new UntypedFormControl(1),
      itemId: ['',],
      //   qtyOutOfStock: new FormControl({ value: '0', disabled: true }),
      minQty: new UntypedFormControl(0),
      minSaleQty: [0, [Validators.required]],
      maxQty: [0, [Validators.required]],
      isQtyDecimal: new UntypedFormControl(1),
      notifyStockQty: [1, [Validators.required]],
      enableQtyIncrements: new UntypedFormControl(0),
      isInStock: new UntypedFormControl(1),

    }));
    if (this.productConfigurable) {
      group.addControl('catalogProductSuperLink', this.formBuilder.array([
        this.catalogProductSuperLink()
      ]));
    }

    if (this.productConfigurable) {
      group.addControl('catalogProductSuperAttribute', this.formBuilder.array([
        this.productRelation()
      ]));


    }

    let i = 0;
    this.regConfig.forEach(element => {


      if (element.attributeGroupId != 0) {

        element['eavEntityAttribute'].forEach(field => {

          if (field.eavAttribute.attributeCode != "special_from_date" || field.eavAttribute.attributeCode != "special_to_date") {

            if (field.eavAttribute['isVisible'] == 1) {
              field.eavAttribute['validations'] = [];

              this.fieldValue = field;
              if (field.eavAttribute.frontendLabel != null && field.eavAttribute['isVisible'] == 1 &&
                field.eavAttribute.frontendLabel != undefined && field.eavAttribute.frontendInput != null) {
                field.eavAttribute['validations'] = [];

                let val = {
                  name: "required",
                  validator: Validators.required,
                  message: " Please fill out this field.",
                }
                if (field.eavAttribute.isRequired == 1) {

                  if (this.invalidMap.get(i) == undefined) {
                    let val =
                      '(' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                    this.invalidMap.set(i, val);
                    this.ValidMap.set(i, val);
                  } else {
                    if (field.eavAttribute.attributeCode != null) {
                      let val = '||' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                      let inval = '&&' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='VALID'"
                      this.invalidMap.set(i, this.invalidMap.get(i) + val);
                      this.ValidMap.set(i, this.ValidMap.get(i) + inval);
                    }
                  }
                  // this.map.set(i,field.eavAttribute.frontendLabel);
                  field.eavAttribute['validations'].push(val);
                  this.validations.push(val);

                }
                if (field.eavAttribute.frontendClass == 2) {
                  let emailval = {
                    name: "pattern",
                    validator: Validators.pattern(
                      "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"
                    ),
                    message: "Invalid email"
                  }
                  field.eavAttribute['validations'].push(emailval);
                  this.validations.push(emailval);
                }
                else if (field.eavAttribute.frontendClass == 1 || field.eavAttribute.frontendClass == 3) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                    message: "Only Numbers"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
                else if (field.eavAttribute.frontendClass == 5) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern('^[a-zA-Z \-\']+'),
                    // validator: Validators.pattern('^[a-zA-Z][\sa-zA-Z]*'),
                    message: "Only  Alphabets"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }

              }


              this.series.push({
                attributeId: field.eavAttribute.attributeId,
                entityTypeId: field.eavAttribute.entityTypeId,
                attributeCode: field.eavAttribute.attributeCode,
                backendType: field.eavAttribute.backendType,
                frontendInput: field.eavAttribute.frontendInput,
              })
              const control = this.formBuilder.control(
                field.eavAttribute.value,
                this.bindValidations(field.eavAttribute.validations || [])
              );
              group.addControl(field.eavAttribute.attributeCode, control);
              //group.controls[field.eavAttribute.attributeCode].setValue(0);

              if (field.eavAttribute.backendType == 'int' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(parseInt(field.eavAttribute.defaultValue), { onlySelf: true });
              }
              else if ((field.eavAttribute.backendType == 'varchar' || field.eavAttribute.backendType == 'text') && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(field.eavAttribute.defaultValue, { onlySelf: true });
              }
              // else if (field.eavAttribute.backendType == 'datetime' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
              //   group.controls[field.eavAttribute.attributeCode].setValue(new Date(field.eavAttribute.defaultValue), { onlySelf: true });
              // }
            }
          }
        });

        // let condition = "this.form.controls.catalogCategoryProduct.status=='INVALID'"

        // this.invalidMap.set(10, condition);
        if (this.invalidMap.get(i) != undefined) {
          let finaloutputInValid = this.invalidMap.get(i) + ')';
          this.invalidMap.set(i, finaloutputInValid);
          let finaloutputValid = this.ValidMap.get(i) + ')';
          this.ValidMap.set(i, finaloutputValid);
        }
        i++;
      }
    });
    return group;
  }



  varientproductformItem(): UntypedFormGroup {
    return this.formBuilder.group({
      varientId: [''],
      productId: [''],
      varientName: [''],
      price: ['0'],
      specialPrice: ['0'],
      skuId: [''],
      weight: [0, [Validators.required]],
      wholeSalePrice: [0],
      wholeSaleSpecialPrice: [0],
      image: [''],
      isInStock: [1],
      qty: [''],
      minQty: [0],
      maxQty: [0],
      renewalPeriod: [1],
      renewalPeriodType: [1],
      productVarientGallery: this.formBuilder.array([]),
    });

  }


  variantGalleryForm(): UntypedFormGroup {
    return this.formBuilder.group({
      valueId: ['',],
      variantId: ['',],
      value: ['',],
      position: ['',]
    });
  }


  addControlsToCatalogCategoryProduct(): UntypedFormGroup {
    return this.formBuilder.group({
      categoryId: ['', [Validators.required]],
      productId: ['', [Validators.required]],
      postion: [''],
    });

  }
  productEntityMediaGallery(): UntypedFormGroup {
    return this.formBuilder.group({
      valueId: ['',],
      attributeId: new UntypedFormControl(88),
      value: ['',],
      productEntityMediaGalleryValue: this.formBuilder.group({
        storeId: new UntypedFormControl(0),
        label: ['',],
        position: new UntypedFormControl(0),
        disabled: new UntypedFormControl(0),
        link: new UntypedFormControl(0),
      })
    });
  }


  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  //edit a Categor
  getProductById(entityId: number) {
    this.productService.getProductById(entityId)
      .subscribe(
        (product: Product) =>
          this.editProduct(product),



        (err: any) => { }
      );

  }

  listOfOptions: any = [];
  editProduct(product: Product) {

    if (this.router.url.includes("/duplicateproduct")) {

      if (product.variant != null) {
        this.productVariant = true;
      }
    }
    this.productData = product;




    if (product['typeId'] == "Booking") {
      if (product['slots'] != undefined) {
        if (product['slots'].length > 0) {
          this.form.setControl('slots',
            this.initTimeSlot(product['slots']));
        }
      }
    }



    if (product.typeId == "Configurable") {

      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Configurations",
        defaultId: 0,
        sort: false
      })


      this.form.setControl('catalogProductSuperLink', this.setValuepatalogProductSuperAttributeLink(product['catalogProductSuperLink']));
      this.form.setControl('catalogProductSuperAttribute', this.setValueproductRelation(product['catalogProductSuperAttribute']));

      this.visibleConfig = true;


    }




    if (product.typeId == "Variants Subscription") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Variants Subscription",
        defaultId: 0,
        sort: false
      })

      if (product.variant != null) {
        this.editvariantInformation(product.variant);
        this.form.value.variant.variantId = this.router.url.includes("/duplicateproduct") ? 0 : product.variant.variantId;
        this.form.patchValue(this.form.value);
      }


      if (product['varientProductItems'] != undefined) {
        this.form.setControl('varientProductItems',
          this.setVarientProduct(product['varientProductItems']));
      }

      this.variantsList = product['varientProductItems'];
    }


    if (product.typeId == "Variants") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Variants",
        defaultId: 0,
        sort: false
      })

      if (product.variant != null) {
        this.editvariantInformation(product.variant);
        this.form.value.variant.variantId = this.router.url.includes("/duplicateproduct") ? 0 : product.variant.variantId;
        this.form.patchValue(this.form.value);
      }


      if (product['varientProductItems'] != undefined) {
        this.form.setControl('varientProductItems',
          this.setVarientProduct(product['varientProductItems']));
      }

      this.variantsList = product['varientProductItems'];
    }



    if (product.typeId == "Booking") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Booking",
        defaultId: 0,
        sort: false
      })

      let index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Inventory')
      if (index >= 0) {
        this.regConfig.splice(index, 1);
      }
      this.bookingEnabled = true;


      // if (product.variant != null) {
      //   this.editvariantInformation(product.variant);
      //   this.form.value.variant.variantId = this.router.url.includes("/duplicateproduct") ? 0 : product.variant.variantId;
      //   this.form.patchValue(this.form.value);
      // }

      // if (product['initDoctorTimeForm'] != undefined) {
      //   this.form.setControl('initDoctorTimeForm',
      //     this.setDoctor(product['initDoctorTimeForm']));
      // }
      this.doctorTimeList = product['initDoctorTimeForm'];
    }

    if (product.typeId == "Services") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Services",
        defaultId: 0,
        sort: false
      })

      let index = this.regConfig.findIndex(x => x['attributeGroupName'] == 'Inventory')
      if (index >= 0) {
        this.regConfig.splice(index, 1);
      }
    }


    if (product.typeId == "Subscription") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Subscription",
        defaultId: 0,
        sort: false
      })


      if (product['subscriptionOccurrences'] != undefined) {
        this.form.setControl('subscriptionOccurrences',
          this.setVarientProduct(product['subscriptionOccurrences']));
      }

      this.subscriptionOccurrencesList = product['subscriptionOccurrences'];

    }





    if (product.typeId == "Course" || product.typeId == "Variants Subscription") {
      this.attributeGroup.push({
        attributeGroupId: 0,
        attributeGroupName: "Course",
        defaultId: 0,
        sort: false
      })

      if (!this.router.url.includes("/duplicateproduct")) {
        if (product['course'] != undefined) {
          this.form.setControl('course',
            this.setCourse(product['course']));
        }
      }

      this.courseList = product['course'];

    }





    this.firstFormGroup.value.typeId = product.typeId;
    let products = product.values;
    this.initalValue = product['values']['name'];
    this.skuInitalValue = product['values']['sku'];
    this.valueId = product.valueIds;
    this.series.forEach(element => {
      let attributeCode = element.attributeCode

      if (attributeCode === 'sku') {
        if (!this.router.url.includes("/duplicateproduct")) {
          this.form.patchValue({
            sku: products[attributeCode]
          });
        }
        return; // always skip further checks for sku
      }


      if (element.frontendInput == 'multiselect' && products[attributeCode] != null) {

        let listOfOptions: any = [];
        products[attributeCode].split(',').forEach(element => {
          listOfOptions.push(parseInt(element))
        });
        this.form.patchValue({
          [attributeCode]: listOfOptions
        });
      }
      else if (element.backendType == 'datetime') {
        this.form.patchValue({
          [attributeCode]: new Date(products[attributeCode]),
        });
      } else {
        this.form.patchValue({
          [attributeCode]: products[attributeCode]
        });
      }
    });
    this.editInventoy(product.catalogInventoryStockItem);
    this.editInventoyStatus(product.catalogInventoryStockStatus)
    this.form.setControl('catalogCategoryProduct', this.editCategory(product.catalogCategoryProduct));
    this.form.setControl('catalogProductLink', this.editCatalogProductLink(product.catalogProductLink));
    if (this.productId > 0) {
      this.mediaGallery = product.productEntityMediaGallery;
    }

    // console.log(this.form.value);


  }
  setValueForProductVarientGallery(productVarientGallery: any) {
    productVarientGallery = {
      valueId: productVarientGallery.valueId,
      variantId: productVarientGallery.variantId,
      value: productVarientGallery.value,
      position: productVarientGallery.position,
    }

    this.firstFormGroup.get('productVarientGallery').patchValue(productVarientGallery);
  }

  varient: any = [];
  addedProductId: any[];



  setVarientProduct(varient: any): any {

    if (varient != undefined) {
      const formArray = new UntypedFormArray([]);
      this.varient = []
      this.addedProductId = []

      let length = 0;
      if (this.form.value.variant.variantLabel2 != null) {

        length = this.form.value.variant.variantLabel2.length

      }
      varient.forEach(varientProductObject => {

        if (this.form.value.variant.variantLabel1.length > 0 &&
          length > 0) {
          const myArray = varientProductObject.varientName.split('-');
          let index = this.variants1.findIndex(x => x == myArray[0])
          if (index < 0) {
            this.variants1.push(myArray[0]);
          }
          let index2 = this.variants2.findIndex(x => x == myArray[1])
          if (index2 < 0) {
            this.variants2.push(myArray[1]);
          }
        } else if (this.form.value.variant.variantLabel1.length > 0) {
          this.variants1.push(varientProductObject.varientName);
        }
        else if (this.form.value.variant.variantLabel2.length > 0) {
          this.variants2.push(varientProductObject.varientName);
        }
        this.varient.push(varientProductObject);
        this.addedProductId.push(varientProductObject.productId);
        formArray.push(this.formBuilder.group({
          varientId: this.router.url.includes("/duplicateproduct") ? 0 : varientProductObject.varientId,
          productId: varientProductObject.productId,
          varientName: varientProductObject.varientName,
          price: varientProductObject.price,
          specialPrice: varientProductObject.specialPrice,
          skuId: varientProductObject.skuId,
          weight: varientProductObject.weight,
          wholeSaleSpecialPrice: varientProductObject.wholeSaleSpecialPrice,
          wholeSalePrice: varientProductObject.wholeSalePrice,
          qty: varientProductObject.qty,
          image: varientProductObject.image,
          isInStock: varientProductObject.isInStock,
          minQty: varientProductObject.minQty,
          maxQty: varientProductObject.maxQty,
          renewalPeriod: varientProductObject.renewalPeriod == null ? 1 : varientProductObject.renewalPeriod,
          renewalPeriodType: varientProductObject.renewalPeriodType == null ? 1 : varientProductObject.renewalPeriodType,
          productVarientGallery: this.setValuproductVarientGalleryItemForm
            (varientProductObject.productVarientGallery),
        }));

      });

      return formArray;
    }
  }

  //Patch Value for Shipment Item
  setValuproductVarientGalleryItemForm(productVarientGallery: any): UntypedFormArray {

    const formArray = new UntypedFormArray([]);

    productVarientGallery.forEach((productVarientGalleryItem, indexShipmentItem) => {
      formArray.push(this.formBuilder.group({
        valueId: productVarientGalleryItem.valueId,
        variantId: productVarientGalleryItem.variantId,
        value: productVarientGalleryItem.value,
        position: productVarientGalleryItem.position
      }));
    });

    return formArray;

  }



  setValueproductRelation(productRelation: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);


    productRelation.forEach(productRelationObject => {

      formArray.push(this.formBuilder.group({
        productSuperAttributeId: productRelationObject['productSuperAttributeId'],
        productId: productRelationObject['productId'],
        attributeId: productRelationObject.attributeId,
        position: productRelationObject.position,
        catalogProductSuperAttributeLabel: {
          storeId: productRelationObject['catalogProductSuperAttributeLabel'].storeId,
          valueId: productRelationObject['catalogProductSuperAttributeLabel'].valueId,
          useDefault: productRelationObject['catalogProductSuperAttributeLabel'].useDefault,
          value: productRelationObject['catalogProductSuperAttributeLabel'].value,
        }
      })

      );
    });

    return formArray;
  }


  setValuepatalogProductSuperAttributeLink(productSuperLins: any): UntypedFormArray {
    const formArray = new UntypedFormArray([]);


    productSuperLins.forEach(productSuperLinkObject => {



      formArray.push(this.formBuilder.group({

        linkId: productSuperLinkObject.linkId,
        productId: productSuperLinkObject.productId,
        parentId: productSuperLinkObject.parentId,
        queryCondition: productSuperLinkObject.queryCondition,
        manageStockSeperately: productSuperLinkObject.manageStockSeperately,
        managePriceSeperately: productSuperLinkObject.managePriceSeperately,
        manageImageSeperately: productSuperLinkObject.manageImageSeperately,
        manageDescriptionSeperately: productSuperLinkObject.manageDescriptionSeperately,
        manageAdditionalInformationSeperately: productSuperLinkObject.manageAdditionalInformationSeperately,
        name: productSuperLinkObject.name,
        sku: productSuperLinkObject.sku,
        manageNameSeperately: productSuperLinkObject.manageNameSeperately

      })

      );
    });

    return formArray;
  }




  editImage(productEntityMediaGallery: ProductEntityMediaGallery[]) {
    if (productEntityMediaGallery.length == 0) {
      this.empty = "true";
    }
    else {
      this.empty = "false"
    }
    const formArray = new UntypedFormArray([]);
    productEntityMediaGallery.forEach(s => {
      formArray.push(this.formBuilder.group({
        valueId: s.valueId,
        attributeId: s.attributeId,
        value: s.value,
        productEntityMediaGalleryValue: {
          storeId: s.productEntityMediaGalleryValue.storeId,
          label: s.productEntityMediaGalleryValue.label,
          position: s.productEntityMediaGalleryValue.position,
          disabled: s.productEntityMediaGalleryValue.disabled,
          link: s.productEntityMediaGalleryValue.link,
        }
      }));
    });
    return formArray;
  }
  editInventoyStatus(catalogInventoryStockStatus: any) {
    catalogInventoryStockStatus = {
      // catalogInventoryStockStatusPK: {
      //   stockId: catalogInventoryStockStatus.stockId,
      //   websiteId: catalogInventoryStockStatus.websiteId,
      // },
      // stockId: catalogInventoryStockStatus.stockId,
      websiteId: catalogInventoryStockStatus.websiteId,
      qty: catalogInventoryStockStatus.qty,
      stockStatus: catalogInventoryStockStatus.stockStatus,
    };
    this.form.get('catalogInventoryStockItem').patchValue(catalogInventoryStockStatus)
  }

  editInventoy(catalogInventoryStockItem: CatalogInventoryStockItem) {
    catalogInventoryStockItem = {
      itemId: this.router.url.includes("/duplicateproduct") ? 0 : catalogInventoryStockItem.itemId,
      manageStock: catalogInventoryStockItem.manageStock,
      qty: parseInt(catalogInventoryStockItem.qty),
      stockId: catalogInventoryStockItem.stockId,
      minQty: catalogInventoryStockItem.minQty,
      minSaleQty: catalogInventoryStockItem.minQty == undefined ? 0.0 : catalogInventoryStockItem.minQty,
      maxQty: catalogInventoryStockItem.maxQty == undefined ? 0.0 : catalogInventoryStockItem.maxQty,
      isQtyDecimal: catalogInventoryStockItem.isQtyDecimal,
      notifyStockQty: catalogInventoryStockItem.notifyStockQty,
      enableQtyIncrements: catalogInventoryStockItem.enableQtyIncrements,
      isInStock: catalogInventoryStockItem.isInStock

    };
    this.form.get('catalogInventoryStockItem').patchValue(catalogInventoryStockItem)
  }



  editvariantInformation(variant: any) {

    variant = {
      variantId: this.router.url.includes("/duplicateproduct") ? 0 : variant.variantId,
      productId: variant.productId,
      variantLabel1: variant.variantLabel1,
      variantLabel2: variant.variantLabel2,
      variantLabel3: variant.variantLabel3,
      variantLabel4: variant.variantLabel4,
      variantLabel5: variant.variantLabel5,
      variantType1: variant.variantType1 == "" ? "1" : variant.variantType1,
      variantType2: variant.variantType2 == "" ? "1" : variant.variantType2,
      variantType3: variant.variantType3,
      variantType4: variant.variantType4,
      variantType5: variant.variantType5,
      maintainStockInd: variant.maintainStockInd,
      maintainPriceInd: variant.maintainPriceInd,
      maintainImageInd: variant.maintainImageInd,
      variantLabel1Filter: variant.variantLabel1Filter,
      variantLabel2Filter: variant.variantLabel2Filter,
      variantLabel3Filter: variant.variantLabel3Filter,
      variantLabel4Filter: variant.variantLabel4Filter,
      variantLabel5Filter: variant.variantLabel5Filter,
    };
    this.form.get('variant').patchValue(variant);
  }


  editCategory(category: CatalogCategoryProduct[]) {
    const formArray = new UntypedFormArray([]);
    let initalSelection = []

    category.forEach(s => {
      this.initalSelectionList.push(s.categoryId);
      this.selection.push(s.categoryId)
      formArray.push(this.formBuilder.group({
        categoryId: s.categoryId,
        position: s.position,
        productId: this.router.url.includes("/duplicateproduct") ? 0 : s.productId
      }));
    });


    // this.toppings.setValue(initalSelection);
    // this.toppings.patchValue(this.toppings.value)
    return formArray;
  }



  // getCategory() {
  //   this.categoryService.categoryList().subscribe(
  //     res => {
  //       this.list = res['responseObject'];
  //     },
  //     error => {

  //     }
  //   );
  // }


  public toggleMenuItem(menuId) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else {
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }
    }
  }


  deleteImage(value, index) {
    let smallImage = this.serverPath3 + value;
    this.imagesToRemoved.push(smallImage);
    let bigImage = this.serverPath1 + value;
    this.imagesToRemoved.push(bigImage);
    let thumnail = this.serverPath2 + value;
    this.imagesToRemoved.push(thumnail);

    if (this.productId == 0 && this.mediaGallery[index].valueId != '') {
      this.productService.deleteImage(this.imagesToRemoved).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.mediaGallery.splice(index, 1);
            this.mediaGallery = this.mediaGallery;
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.text = "Save"
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });
    } else {
      this.mediaGallery.splice(index, 1);
    }
  }

  selected(event, i) {



    const formArray = this.form.get('catalogCategoryProduct') as UntypedFormArray;
    if (event.target.checked) {

      if (this.form.value.catalogCategoryProduct[0].productId.length == 0) {
        formArray.removeAt(0);
      }

      let array = this.formBuilder.group({
        categoryId: i,
        postion: 0,
        productId: parseFloat(this.productId),
      });
      (<UntypedFormArray>this.form.get('catalogCategoryProduct')).push(array);
      this.form.patchValue(this.form.value)

      this.selection.push(i)

    } else {
      if (this.form.value.catalogCategoryProduct.length == 1) {

        (<UntypedFormArray>this.form.get('catalogCategoryProduct')).push(this.addControlsToCatalogCategoryProduct());
      }
      let indexUnassigned = this.form.value.catalogCategoryProduct.findIndex(x => x.categoryId == i);
      formArray.removeAt(indexUnassigned);
      var indexCheckValue = this.selection.indexOf(i);
      if (indexCheckValue > -1) {
        this.selection.splice(indexCheckValue, 1);
      }


    }
  }

  addOrEditProduct() {
    if (this.productId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {

      if (this.productId == 0) {
        this.checkSameProductName();
        this.sameProductName = false;
      }
      else if (this.productId > 0 && this.skuInitalValue != this.form.value.sku) {
        this.checkSameProductName();
        this.sameProductName = false;
      }
      else {
        this.sameProductName = true;
        this.saveProduct();
      }

    }


  }


  saveProduct() {

    if (this.form.valid && this.sameProductName) {


      this.text = "Processing"

      const differences = this.selection.filter(x => !this.initalSelectionList.includes(x))
        .concat(this.initalSelectionList.filter(x => !this.selection.includes(x)));

      if (this.mediaGallery.length > 0) {


        var min = Math.min(...this.mediaGallery.map(item => item.productEntityMediaGalleryValue.position));

        for (let imageObject of this.mediaGallery) {

          if (min == imageObject.productEntityMediaGalleryValue.position) {
            this.form.value.image = imageObject.value;
            this.form.value.small_image = imageObject.value;
            this.form.value.thumbnail = imageObject.value;
            break;
          }
        }

      } else {
        this.form.value.image = null;
        this.form.value.small_image = null;
        this.form.value.thumbnail = null;
      }
      if (this.form.value.catalogInventoryStockItem.qty.length >= 10) {
        this.form.value.catalogInventoryStockItem.qty = 99999999.9999;


      }

      if (this.productId == 0 && this.firstFormGroup.value.type == "Variants") {
        this.productVariant = true;
      }

      if (this.productId == 0 && this.firstFormGroup.value.type == "Variants Subscription") {
        this.productVariant = true;
      }


      if (this.form.value.special_price == null) {
        this.form.value.special_price = 0.0;

      }


      if (this.form.value.catalogInventoryStockItem.notifyStockQty.length >= 10) {
        this.form.value.catalogInventoryStockItem.notifyStockQty = 99999999.9999;
      }
      this.form.value.catalogInventoryStockStatus.productId = this.productId;
      this.form.value.catalogInventoryStockStatus.qty = parseFloat(this.form.value.catalogInventoryStockItem.qty);
      this.form.value.catalogInventoryStockStatus.stockStatus = this.form.value.catalogInventoryStockItem.isInStock;
      let catalogProductEntity = {
        productVarchar: [],
        productInt: [],
        productText: [],
        productDecimal: [],
        productDateTime: [],
        catalogProductEntityStatic: [],
        catalogCategoryProduct: this.form.value.catalogCategoryProduct,
        catalogInventoryStockItem: this.form.value.catalogInventoryStockItem,
        catalogInventoryStockStatus: this.form.value.catalogInventoryStockStatus,
        catalogProductSuperAttribute: !this.productConfigurable ? [] : this.form.value.catalogProductSuperAttribute.length > 0 ? this.form.value.catalogProductSuperAttribute : this.catalogProductSuperAttributeList,
        catalogProductSuperLink: !this.productConfigurable ? [] : this.form.value.catalogProductSuperLink.length > 0 ? this.form.value.catalogProductSuperLink : this.catalogProductSuperLinkList,
        varientProductItems: this.form.value.varientProductItems,
        variant: !this.productVariant ? null : this.form.value.variant,
        slots: this.form.value.slots,
        course: this.form.value.course,
      }


      if (this.form.value.catalogProductLink != undefined) {

        if (this.form.value.catalogProductLink.length > 0) {
          catalogProductEntity['catalogProductLink'] = this.form.value.catalogProductLink[0].linkedProductId > 0 ? this.form.value.catalogProductLink : []
        }

      }
      for (let i = 0; i < this.series.length; i++) {


        if (this.form.value[this.series[i].attributeCode] != null) {

          this.series[i].value = this.form.value[this.series[i].attributeCode];


          if (this.productId > 0) {
            this.series[i].valueId = parseInt(this.valueId[this.series[i].attributeCode]);
          }
          this.series[i].storeId = 1;
          if (this.series[i].backendType == "varchar" && this.series[i].value != null && this.series[i].frontendInput == "multiselect" && this.series[i]) {

            this.series[i].value = this.series[i].value.toString();
            catalogProductEntity.productVarchar.push(this.series[i])
          }
          else if (this.series[i].backendType == "varchar" && this.series[i]) {
            catalogProductEntity.productVarchar.push(this.series[i])
          } else if (this.series[i].backendType == "int") {

            let value = this.series[i].value;
            if (Number.isInteger(value)) {
              catalogProductEntity.productInt.push(this.series[i]);
            }
          }
          else if (this.series[i].backendType == "text") {
            catalogProductEntity.productText.push(this.series[i])
          } else if (this.series[i].backendType == "decimal") {
            if (this.series[i].value == null) {
              this.series[i].value = 0.0;
              this.series[i].value = parseFloat(this.series[i].value)
            }

            catalogProductEntity.productDecimal.push(this.series[i])
          }
          else if (this.series[i].backendType == "datetime") {

            if (this.series[i].value != null) {

              if (this.productId == 0) {
                this.series[i].value.setDate(this.series[i].value.getDate() + 1);


              } else {

                let value = this.productData['values'][this.series[i].attributeCode];

                if (value != null) {

                  let actualDate = this.datepipe.transform(this.series[i].value, 'yyyy-MM-dd');

                  let endDate = this.datepipe.transform(value, 'yyyy-MM-dd');


                  if (actualDate != endDate) {
                    this.series[i].value.setDate(this.series[i].value.getDate() + 1);
                  }

                }

              }

              catalogProductEntity.productDateTime.push(this.series[i])
            }


          }
          else {
            catalogProductEntity.catalogProductEntityStatic.push(this.series[i])
          }

        }


      }

      catalogProductEntity['operationType'] = this.productId == 0 ? "NEW" : "CHANGE";
      catalogProductEntity['sku'] = this.form.value.sku;
      catalogProductEntity['entityTypeId'] = 4;
      catalogProductEntity['attributeSetId'] = this.entityValue.attributeSetId;
      catalogProductEntity['typeId'] = this.productId == 0 ? this.entityValue.typeId : this.firstFormGroup.value.typeId;
      catalogProductEntity['hasOptions'] = 4;
      catalogProductEntity['productEntityMediaGallery'] = this.mediaGallery;

      catalogProductEntity['categoryRemoved'] = differences;
      if (this.productId > 0) {
        catalogProductEntity['entityId'] = this.productId;
        catalogProductEntity['imageRemove'] = this.imagesToRemoved;
      }

      if (this.router.url.includes("/duplicateproduct")) {
        catalogProductEntity['typeId'] = this.firstFormGroup.value.typeId;
      }

      this.productService.addProduct(catalogProductEntity).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.router.navigate(['product']);
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.text = "Save"
          }

          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }

        },
        (err) => { });




    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }
  checkSameProductName() {
    let payload = {
      "name": this.form.value.name,
      "sku": this.form.value.sku
    }
    this.productService.productNameExists(payload).subscribe(
      (response) => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.sameProductName = true;
          this.saveProduct();
        }
        else {
          this.snackBar.open(" Product with Same Sku " + '"' +
            this.form.value.sku + '"' + "   already exists ", '×',
            { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.sameProductName = true
      });

    return this.sameProductName;
  }


  getResult(event) {

    if (this.mediaGallery.length <= 0) {
      this.mediaGallery = event.productEntityMediaGallery;
    } else {
      this.mediaGallery = this.mediaGallery.concat(event.productEntityMediaGallery);
    }
    this.snackBar.open("Image Uploaded Successfully..", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
  }



  getCategory() {
    this.categoryService.categoryListWithoutInActiveCategory().subscribe(
      res => {
        this.list = res['data'];
      },
      error => {

      }
    );
  }

  // toppings = new FormControl();
  // getCategory() {
  //   this.categoryService.categoryListWithoutPagination().subscribe(
  //     res => {

  //       this.list = res['content'];
  //     },
  //     error => {

  //     }
  //   )
  // }

  // filterMUlto(i, j) {

  //   if (i.isUserInput) {
  //     let array = this.formBuilder.group({
  //       categoryId: j.categoryId,
  //       postion: 0,
  //       productId: parseFloat(this.productId),
  //     });
  //     (<FormArray>this.form.get('catalogCategoryProduct')).push(array);


  //    // this.form.value.catalogCategoryProduct[this.form.value.catalogCategoryProduct.length].categoryId = j.categoryId
  //    // this.form.value.catalogCategoryProduct[this.form.value.catalogCategoryProduct.length].productId = this.productId
  //     this.form.patchValue(this.form.value)
  //
  //   }
  // }


  checkValidataion(i) {

    return eval(this.invalidMap.get(i));

  }

  drawerChange(drawerOpen: boolean) {
    this.screenSizeService.drawerOpen.next(drawerOpen);
  }

  openDrawer() {
    this.screenSizeService.drawerOpen.next(true);
    this.cd.markForCheck();
  }

  closeDrawer() {
    this.screenSizeService.drawerOpen.next(false);
    this.cd.markForCheck();
  }

  @ViewChild(ScrollbarComponent, { static: true }) scrollbar: ScrollbarComponent;
  public tabsContentRef!: ScrollbarComponent;
  scrollToBottom() {
    this.tabsContentRef?.scrollbarRef.getScrollElement().scrollTo({
      behavior: 'smooth',
      top: 0
    });

  }

  onActivate() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  duplicate() {

    this.router.navigate([`product/duplicateproduct/${this.productId}/${this.route.snapshot.params['setId']}`])
  }


  attributeSetFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }


  protected attributeFilter() {
    if (!this.attributeSetList) {
      return;
    }
    // get the search keyword
    let search = this.attributeFilterControl.value;
    if (!search) {
      this.filteredAttributeList = this.attributeSetList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAttributeList = this.attributeSetList.filter(attributeSetName => attributeSetName['attributeSetName'].toLowerCase().indexOf(search) > -1)
  }


  ///\

  productRelation(): UntypedFormGroup {
    return this.formBuilder.group({
      productSuperAttributeId: ['',],
      productId: [''],
      attributeId: [''],
      position: ['',],
      catalogProductSuperAttributeLabel: this.formBuilder.group({
        valueId: new UntypedFormControl(0),
        storeId: new UntypedFormControl(0),
        useDefault: new UntypedFormControl(0),
        value: [''],


      }),
    });
  }




  catalogProductSuperLink(): UntypedFormGroup {
    return this.formBuilder.group({
      linkId: ['',],
      productId: ['',],
      parentId: ['',],
      queryCondition: [''],
      manageStockSeperately: ['',],
      managePriceSeperately: [''],
      manageImageSeperately: [''],
      manageDescriptionSeperately: [''],
      manageAdditionalInformationSeperately: [''],
      name: [''],
      sku: [''],
      manageNameSeperately: ['']
    });
  }


  removeAssociatedProduct(i, linkId) {
    (<UntypedFormArray>this.form.get('catalogProductSuperLink')).removeAt(i);

    if (this.form.value.catalogProductSuperLink.length == 0) {
      (<UntypedFormArray>this.form.get('catalogProductSuperAttribute')).clear();
    }
    this.productService.deleteByAssociatedProductId(linkId, this.form.value.catalogProductSuperLink.length, this.productId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      error => {

      })

  }


  addControlsToCatalogProductLink(): UntypedFormGroup {
    return this.formBuilder.group({
      linkId: ['',],
      productId: [0],
      linkedProductId: [0],
      linkTypeId: [0],
      name: [''],
      sku: [''],
      price: ['']
    });

  }


  productLinkPopup(linkTypeId, title) {
    let productLinkId = []
    let enabled = false;
    if (linkTypeId == 1) {
      productLinkId = this.relatedProductList;
      this.productSuperLinkList = this.relatedProductList;
      enabled = this.relatedSell

    } else if (linkTypeId == 4) {
      productLinkId = this.upSellsProductList;
      this.productSuperLinkList = this.upSellsProductList;
      enabled = this.upSell
    } else if (linkTypeId == 5) {
      productLinkId = this.crossSellsProductList;
      this.productSuperLinkList = this.crossSellsProductList;

      enabled = this.crossSell
    }


    if (!enabled) {
      if (window.innerWidth > 768) {

        let dialogRef = this.dialog.open(ProductLinkComponent, {
          width: '1000px',
          disableClose: true,
          data: {
            productId: this.productId, setId: this.firstFormGroup.value.attributeSet,
            linkTypeId: linkTypeId, superLinkList: productLinkId, title: title, oldList: productLinkId
          }
        });


        dialogRef.afterClosed().subscribe(result => {

          if (result['event'] == 'add') {


            this.productLinkList = [...this.productLinkList, ...result['productLinkList']];


            if (this.form.value.catalogProductLink != undefined) {

              if (this.form.value.catalogProductLink.length > 0) {
                (<UntypedFormArray>this.form.get('catalogProductLink')).clear();
              }

            }


            this.form.setControl('catalogProductLink', this.editCatalogProductLink
              (this.productLinkList));

          }

        });
      }
      else {
        let dialogRef = this.dialog.open(ProductLinkComponent, {
          minWidth: '100vw', height: '100vh',
          disableClose: true,
          data: { productId: this.productId, setId: this.firstFormGroup.value.attributeSet, linkTypeId: linkTypeId, superLinkList: productLinkId, title: title, oldList: productLinkId }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result['event'] == 'add') {


            this.productLinkList = [...this.productLinkList, ...result['productLinkList']];


            if (this.form.value.catalogProductLink != undefined) {

              if (this.form.value.catalogProductLink.length > 0) {
                (<UntypedFormArray>this.form.get('catalogProductLink')).clear();
              }

            }


            this.form.setControl('catalogProductLink', this.editCatalogProductLink
              (this.productLinkList));

          }

        });
      }
    }

  }



  editCatalogProductLink(productLink: any[]) {
    this.relatedProducts = []
    this.relatedProductList = []
    this.upSellsProduct = [];
    this.upSellsProductList = []
    this.crossSellsProduct = []
    this.crossSellsProductList = [];
    this.relatedProductList.push(this.productId)
    this.upSellsProductList.push(this.productId)
    this.crossSellsProductList.push(this.productId)
    if (productLink != undefined && productLink.length > 0) {
      const formArray = new UntypedFormArray([]);
      let initalSelection = []
      this.productLinkList = productLink;

      productLink.forEach(productLinkObject => {

        if (productLinkObject.linkTypeId == 1) {
          this.relatedProducts.push(productLinkObject);
          this.relatedProductList.push(productLinkObject.linkedProductId)
        } else if (productLinkObject.linkTypeId == 4) {
          this.upSellsProduct.push(productLinkObject);
          this.upSellsProductList.push(productLinkObject.linkedProductId)
        } else if (productLinkObject.linkTypeId == 5) {
          this.crossSellsProduct.push(productLinkObject);
          this.crossSellsProductList.push(productLinkObject.linkedProductId)
        }

        formArray.push(this.formBuilder.group({
          linkId: productLinkObject.linkId,
          productId: productLinkObject.productId,
          linkedProductId: productLinkObject.linkedProductId,
          linkTypeId: productLinkObject.linkTypeId,
          name: productLinkObject.name,
          sku: productLinkObject.sku,
          price: productLinkObject.price
        }));
      });
      return formArray;
    }
  }


  removeLinkedProduct(index, productLinkObject) {

    if (this.form.value.catalogProductLink.length > 0) {

      let arrayControl: any = [];

      arrayControl = this.form.get('catalogProductLink') as UntypedFormArray;
      arrayControl = arrayControl.value;
      let formIndex = 0;
      let productLinkListIndex = 0;
      if (productLinkObject.linkId > 0) {
        arrayControl.forEach((element, index) => {
          if ((element.linkedProductId == productLinkObject.linkedProductId) && (element.linkTypeId == productLinkObject.linkTypeId)) {
            formIndex = index;
          }
        });
        (<UntypedFormArray>this.form.get('catalogProductLink')).removeAt(formIndex);
        let productLinkListIndex = this.productLinkList.findIndex(x => x.linkId == productLinkObject.linkId)
        this.productLinkList.splice(productLinkListIndex, 1);
      } else {
        arrayControl.forEach((element, index) => {
          if ((element.linkedProductId == productLinkObject.linkedProductId) && (element.linkTypeId == productLinkObject.linkTypeId)) {
            formIndex = index;
          }
        });
        (<UntypedFormArray>this.form.get('catalogProductLink')).removeAt(formIndex);
        this.productLinkList.forEach((element, index) => {
          if ((element.linkedProductId == productLinkObject.linkedProductId) && (element.linkTypeId == productLinkObject.linkTypeId)) {
            productLinkListIndex = index;
          }
        });
        this.productLinkList.splice(productLinkListIndex, 1);
      }
      console.log(this.productLinkList)

      if (productLinkObject.linkTypeId == 1) {

        let productLinkIndex = this.relatedProducts.findIndex(x => x.linkedProductId == productLinkObject.linkedProductId)

        this.relatedProducts.splice(productLinkIndex, 1);

        let superLinkListIndex = this.relatedProductList.findIndex(x => x == productLinkObject.linkedProductId)
        this.relatedProductList.splice(superLinkListIndex, 1);

      } else if (productLinkObject.linkTypeId == 4) {
        let productLinkIndex = this.upSellsProduct.findIndex(x => x.linkedProductId == productLinkObject.linkedProductId)

        this.upSellsProduct.splice(productLinkIndex, 1);

        let superLinkListIndex = this.upSellsProductList.findIndex(x => x == productLinkObject.linkedProductId)
        this.upSellsProductList.splice(superLinkListIndex, 1);

      } else if (productLinkObject.linkTypeId == 5) {

        let productLinkIndex = this.crossSellsProduct.findIndex(x => x.linkedProductId == productLinkObject.linkedProductId)

        this.crossSellsProduct.splice(productLinkIndex, 1);

        let superLinkListIndex = this.crossSellsProductList.findIndex(x => x == productLinkObject.linkedProductId)
        this.crossSellsProductList.splice(superLinkListIndex, 1);
      }
    }
  }
  _keyPress(event: any) {
    const pattern = /[^0-9.]*/;
    let inputChar = String.fromCharCode(event.charCode).trim();

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    } else if (inputChar.length == 0) {
      event.preventDefault();
    }

  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.openDrawer()
  }


  getConfigData() {
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        localStorage.setItem("value", JSON.stringify(data))
        this.data = data;

        if (data['updateStockByPurchaseOnly'] == 1) {
          this.updateStockByPurchaseOnly = true;
        } else {
          this.updateStockByPurchaseOnly = false;
        }
        if (data['b2bPricingEnabled'] == 1) {
          this.b2bPricingEnabled = true;
        } else {
          this.b2bPricingEnabled = false;
        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  @ViewChild('variantInformation') variantInformation: TemplateRef<any>;
  varientProductItemsCopy: any = [];
  removedVariant1: any = [];
  removedVariant2: any = [];
  variantNameCopy2: any;
  variantNameCopy1: any;
  addVarient() {

    this.variantNameCopy1 = this.form.value.variant.variantLabel1;

    this.variantNameCopy2 = this.form.value.variant.variantLabel2;

    this.varientProductItemsCopy = this.form.value.varientProductItems;

    this.removedVariant1 = [];
    this.removedVariant2 = [];
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.variantInformation, {
        disableClose: true,
        width: '900px',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }
    else {
      let dialogRef = this.dialog.open(this.variantInformation, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }

  }

  @ViewChild('variantSubscription') variantSubscription: TemplateRef<any>;
  addSubscription() {

    this.variantNameCopy1 = this.form.value.variant.variantLabel1;

    this.variantNameCopy2 = this.form.value.variant.variantLabel2;

    this.varientProductItemsCopy = this.form.value.varientProductItems;

    this.removedVariant1 = [];
    this.removedVariant2 = [];
    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.variantSubscription, {
        disableClose: true,
        width: '900px',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }
    else {
      let dialogRef = this.dialog.open(this.variantSubscription, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }

  }

  close() {
    this.dialog.closeAll();
    this.courseForm.reset();


  }

  addVariant() {
    if (this.form.value.variant.variantLabel2.length > 0 && this.variants2.length == 0) {
      alert("Please Fill the Sub Variant 2");
    } else if (this.form.value.variant.variantLabel1.length > 0 && this.variants1.length == 0) {
      alert("Please Fill the Sub Variant 1");
    } else {
      if (this.form.value.varientProductItems.length != 0) {
        if (this.form.value.varientProductItems[0].varientName == '') {
          const formArray = this.form.get('varientProductItems') as FormArray;
          formArray.removeAt(0);
        }
      }
      this.setProductItem();
      this.close();
    }
  }





  setProductItem() {

    if (this.form.value.variant.variantLabel2 != this.variantNameCopy2
      || this.form.value.variant.variantLabel1 != this.variantNameCopy1
    ) {
      this.deleteAllFormArrays();

    }
    if (this.form.value.variant.variantLabel1.length > 0
      && this.form.value.variant.variantLabel2.length <= 0) {

      if (this.form.value.variant.variantLabel1 != this.variantNameCopy1) {
        (<UntypedFormArray>this.form.get('varientProductItems')).clear();
      }
      this.setValueItemSingle('variants1', 'removedVariant1');
    } else if (this.form.value.variant.variantLabel2.length > 0 && this.form.value.variant.variantLabel1.length <= 0) {
      if (this.form.value.variant.variantLabel2 != this.variantNameCopy2) {
        (<UntypedFormArray>this.form.get('varientProductItems')).clear();
      }
      this.setValueItemSingle('variants2', 'removedVariant1');
    }
    else if (this.form.value.variant.variantLabel1 != this.variantNameCopy1) {
      this.deleteAllFormArrays();
    } else if (this.form.value.variant.variantLabel2 != this.variantNameCopy2) {
      this.deleteAllFormArrays();
    } else {
      this.setValueItem();
    }

  }

  setValueItemSingle(list: any, removeListName: any) {

    const varientProductItems = this.form.get
      ('varientProductItems') as FormArray;

    this[list].forEach((variant1, i) => {

      const variantName = `${variant1}`;

      console.log(this.form.value.varientProductItems);

      const existingVariant = varientProductItems.controls.
        find(control => control.get('varientName').value === variantName);
      if (!existingVariant) {
        varientProductItems.push(this.formBuilder.group({
          varientId: [0],
          productId: [''],
          varientName: [variantName],
          price: [0.0],
          specialPrice: [0.0],
          skuId: [variantName],
          weight: [0, [Validators.required]],
          image: [''],
          isInStock: [1],
          qty: [0.0],
          wholeSalePrice: [0],
          wholeSaleSpecialPrice: [0],
          minQty: [0],
          maxQty: [0],
          renewalPeriod: [1],
          renewalPeriodType: [1],
          productVarientGallery: this.formBuilder.array([]),
        }));
      }

    });

    if (this[removeListName].length > 0) {

      this.removedValue(removeListName)
    }



    this.variantsList = this.form.value.varientProductItems;

    // console.log(this.form.value);

  }


  removedValue(removedListName: any) {
    // const formArray = this.form.get('varientProductItems') as FormArray;

    // formArray.controls.forEach((formGroup: FormGroup) => {
    //   const variantName = formGroup.get('varientName').value;

    //   this[removedListName].forEach(element => {
    //     if (variantName.includes(element)) {
    //       formArray.removeAt(formArray.controls.indexOf(formGroup));
    //     }
    //   });
    // });
    const formArray = this.form.get('varientProductItems') as FormArray;

    for (let i = formArray.controls.length - 1; i >= 0; i--) {
      const formGroup = formArray.controls[i] as FormGroup;
      const variantName = formGroup.get('varientName').value;

      this[removedListName].forEach(element => {

        const parts = variantName.split('-');
        let label1 = '';
        let label2 = '';
        if (parts.length > 1) {
          label1 = parts[0];
          label2 = parts[1];
        } else {
          label1 = variantName;
          label2 = "nothing";
        }

        let value = '';
        if (removedListName == 'removedVariant1') {
          value = label1;
        } else {
          value = label2;
        }
        if (value == element) {
          formArray.removeAt(i);
        }
      });
    }
  }


  deleteAllFormArrays() {
    (<UntypedFormArray>this.form.get('varientProductItems')).clear();
    this.setValueItem();
  }

  setValueItem() {

    const varientProductItems = this.form.get('varientProductItems') as FormArray;

    this.variants1.forEach((variant1, i) => {
      this.variants2.forEach((variant2, j) => {
        const variantName = `${variant1}-${variant2}`;
        const existingVariant = varientProductItems.controls.
          find(control => control.get('varientName').value === variantName);
        if (!existingVariant) {
          varientProductItems.push(this.formBuilder.group({
            varientId: [0],
            productId: [''],
            varientName: [variantName],
            price: [0.0],
            specialPrice: [0.0],
            skuId: [variantName],
            weight: [0, [Validators.required]],
            image: [''],
            isInStock: [1],
            qty: [0.0],
            wholeSalePrice: [0],
            wholeSaleSpecialPrice: [0],
            minQty: [0],
            maxQty: [0],
            renewalPeriod: [1],
            renewalPeriodType: [1],
            productVarientGallery: this.formBuilder.array([

            ])
          }));
        }
      });
    });



    if (this.removedVariant1.length > 0) {

      this.removedValue('removedVariant1')
    }

    if (this.removedVariant2.length > 0) {

      this.removedValue('removedVariant2')

    }

    this.variantsList = this.form.value.varientProductItems;

    // console.log(this.form.value);

  }
  varientProductGallery(): UntypedFormGroup {
    return this.formBuilder.group({
      valueId: [''],
      variantId: [''],
      value: [''],
      position: [''],
    });
  }



  selectable = true;
  removable = true;
  addOnBlur = true;
  editable = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  editMode: boolean[] = [];
  remove(variantObject: any, variant): void {
    const index = this[variant].indexOf(variantObject);

    if (index >= 0) {
      this[variant].splice(index, 1);
    }

    if (variant == 'variants1') {

      this.removedVariant1.push(variantObject)
    } else {
      this.removedVariant2.push(variantObject)
    }


  }

  add(event: MatChipInputEvent, variant): void {

    if (event.value.length > 0) {


      const input = event.input;
      const value = event.value;

      const index = this[variant].indexOf(event.value);

      const result = this[variant].find(item => item.toLowerCase() === event.value.toLowerCase());

      if (result) {
        this.snackBar.open('Variant already exists', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      } else {
        this[variant].push(value);
      }

      // Reset the input value
      if (input) {
        input.value = "";
      }
    }
  }

  textAccount: string;

  configTypeList = [
    { viewValue: "DropDown", value: "1" },
    { viewValue: "Image", value: "2" },
    { viewValue: "Button", value: "3" },
    { viewValue: "Colour", value: "4" }
  ]

  configTypeVarientSubscription = [
    { viewValue: "Date", value: "1" },
  ]

  booleanField1: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  booleanField2: any = [
    { "value": "1", "viewValue": "Yes" },
    { "value": "0", "viewValue": "No" },
  ]



  expandedRow: any = null;

  expandRow(rowData) {
    if (this.expandedRow === rowData) {
      this.expandedRow = null;
    } else {
      this.expandedRow = rowData;
    }
  }
  toggle(item) {
    item.expanded = !item.expanded;
  }


  imageAdded: any = [];
  @ViewChild('variantImage') variantImage: TemplateRef<any>;
  addImage(imageObject, index) {

    this.imageAdded = [];

    this.currentIndex = index;

    if (imageObject != null) {

      imageObject.forEach(element => {

        this.imageAdded.push(element['value']);

      });
    }



    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.variantImage, {
        disableClose: true,
        width: '900px',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }
    else {
      let dialogRef = this.dialog.open(this.variantImage, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }

  }

  onChangeImage(ImageInfo, isChecked: boolean) {

    let index = this.imageAdded.findIndex(x => x == ImageInfo.value)
    if (isChecked) {

      if (index < 0) {
        this.imageAdded.push(ImageInfo.value);
      }
    } else {
      this.imageAdded.splice(index, 1);

    }
  }

  addImageToProductVarientGallery() {

    this.close()

    this.setProductVarientGallery();
  }

  setProductVarientGallery() {

    var arrayControl = this.form.get('varientProductItems') as FormArray;

    let productVarientGallery = arrayControl.
      at(this.currentIndex).get('productVarientGallery') as FormArray

    if (productVarientGallery == null) {

      productVarientGallery = new FormArray([])
    }




    this.imageAdded.forEach((imageNameObject, i) => {


      let existingVariant = null;
      if (productVarientGallery != null) {
        existingVariant = productVarientGallery.controls.find(control =>
          control.get('value').value === imageNameObject);
      } else {
        existingVariant = null;
      }


      if (existingVariant == null) {
        productVarientGallery.push(this.formBuilder.group({
          valueId: 0,
          variantId: productVarientGallery.value.variantId,
          value: imageNameObject,
          position: 0
        }));
      }
      else if (!existingVariant) {
        productVarientGallery.push(this.formBuilder.group({
          valueId: 0,
          variantId: productVarientGallery.value.variantId,
          value: imageNameObject,
          position: 0
        }));
      }

    });


    if (productVarientGallery.value[0].value == '') {

      productVarientGallery.removeAt(0);
    }





  }


  removeProductVarientGalleryImage(index, secondaryIndex) {

    var arrayControl = this.form.get('varientProductItems') as FormArray;

    const productVarientGallery = arrayControl.
      at(index).get('productVarientGallery') as FormArray

    productVarientGallery.removeAt(secondaryIndex)

  }

  @ViewChild('download') download: TemplateRef<any>;

  openDialog() {
    let dialogRef = this.dialog.open(this.download, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  addLink() {

    let object = {
      valueId: 0,
      attributeId: 88,
      value: this.secondFormGroup.value.imageLink,
      productEntityMediaGalleryValue: {
        storeId: 0,
        label: null,
        position: 0,
        disabled: 0,
        link: 1,
      }
    }
    this.secondFormGroup.reset();
    this.mediaGallery.push(object);
  }



  secondFormGroup = this._formBuilder.group({
    imageLink: ['', Validators.required],

  });

  thirdFormGroup = this._formBuilder.group({
    specialDiscount: [''],
  })

  submit1() {
    if (this.secondFormGroup.valid) {
      console.log(this.secondFormGroup);
      this.addLink();
      this.dialog.closeAll();
    }
    else {
      this.validateAllFormFields(this.secondFormGroup);

    }
  }


  @ViewChild('special') special: TemplateRef<any>;

  openDialog1() {
    let dialogRef = this.dialog.open(this.special, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  submit2() {
    if (this.thirdFormGroup.valid) {
      console.log(this.thirdFormGroup);
      this.dialog.closeAll();
    }
    else {
      this.validateAllFormFields(this.thirdFormGroup);

    }
  }


  address_validation_messages = {
    'imageLink': [
      { type: 'required', message: 'Please fill out this field.' },
      { type: 'pattern', message: 'Enter a Valid Format' },
    ],
    morningTimeFrom: [
      { type: 'required', message: 'Please fill out this field.' },
      {
        type: 'minlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
      {
        type: 'maxlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
    ],
    morningTimeTo: [
      { type: 'required', message: 'Please fill out this field.' },
      {
        type: 'minlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
      {
        type: 'maxlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
    ],
    eveningTimeFrom: [
      { type: 'required', message: 'Please fill out this field.' },
      {
        type: 'minlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
      {
        type: 'maxlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
    ],
    eveningTimeTo: [
      { type: 'required', message: 'Please fill out this field.' },
      {
        type: 'minlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
      {
        type: 'maxlength',
        message: 'Enter a valid Contact Number Only 6 Digits',
      },
    ],
    telephone: [
      { type: 'required', message: 'Please fill out this field.' },

      {
        type: 'maxlength',
        message: 'Last Name  cannot be more than 25 characters long',
      }
    ]

  }


  restritionPopup(value) {

    if (value == 'related' && this.relatedSell) {
      let dialogRef = this.dialog.open(RestrictionComponent, {
        width: '350px',
        // disableClose: false,
      });
    }
    else if (value == 'crosssell' && this.crossSell) {
      let dialogRef = this.dialog.open(RestrictionComponent, {
        width: '350px',
        // disableClose: false,
      });
    }
    else if (value == 'upsell' && this.upSell) {
      let dialogRef = this.dialog.open(RestrictionComponent, {
        width: '350px',
        // disableClose: false,
      });
    }

    // dialogRef.disableClose = false;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
    }
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;


  }

  weightFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/)
  ]);


  //doctor

  doctorTimeList: any = []

  initTimeSlot(value): UntypedFormArray {

    if (value == 0) {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
        'Friday', 'Saturday'];
      const defaultFormArray = new UntypedFormArray([]);

      daysOfWeek.forEach(day => {
        defaultFormArray.push(this.formBuilder.group({
          value_id: 0,
          parentId: 0,
          day: day,
          morningTimeFrom: '',
          morningTimeTo: '',
          eveningTimeFrom: '',
          eveningTimeTo: '',

        }));
      });

      return defaultFormArray;
    } else {
      const formArray = new UntypedFormArray([]);
      value.forEach(doctorTime => {
        formArray.push(this.formBuilder.group({
          id: doctorTime.id,
          doctorId: doctorTime.doctorId,
          day: doctorTime.day,
          morningTimeFrom: doctorTime.morningTimeFrom,
          morningTimeTo: doctorTime.morningTimeTo,
          eveningTimeFrom: doctorTime.eveningTimeFrom,
          eveningTimeTo: doctorTime.eveningTimeTo,
          createdAt: doctorTime.createdAt,
          updatedAt: doctorTime.updatedAt,

        })
        );

      });
      return formArray;

    }

  }


  initCourseArray(): UntypedFormGroup {
    return this.formBuilder.group({
      courseId: new UntypedFormControl(0),
      title: ['', []],
      productId: ['', []],
      active: ['', []],
      customField1: ['', []],
      customField2: ['', []],
      customField3: ['', []],
      customField4: ['', []],
      customField5: ['', []],
      customField6: ['', []],
      customField7: ['', []],
      customField8: [''],
      customField9: [''],
      customField10: [''],
      courseItem: this.formBuilder.array([]),
    });

  }


  course: any = [];

  setCourse(course: any): any {

    if (course != undefined) {
      const formArray = new UntypedFormArray([]);
      this.varient = []
      this.addedProductId = []
      course.forEach(courseObject => {
        formArray.push(this.formBuilder.group({
          courseId: this.router.url.includes("/duplicateproduct") ? 0 : courseObject.courseId,
          title: courseObject.title,
          productId: this.router.url.includes("/duplicateproduct") ? 0 : courseObject.productId,
          active: courseObject.active,
          customField1: courseObject.customField1,
          customField2: courseObject.customField2,
          customField3: courseObject.customField3,
          customField4: courseObject.customField4,
          customField5: courseObject.customField5,
          customField6: courseObject.customField6,
          customField7: courseObject.customField7,
          customField8: courseObject.customField8,
          customField9: courseObject.customField9,
          customField10: courseObject.customField10,
          courseItem: this.setValuCourseItemForm
            (courseObject.courseItem),
        }));

      });

      return formArray;
    }
  }

  //Patch Value for Shipment Item
  setValuCourseItemForm(courseItem: any): UntypedFormArray {

    const formArray = new UntypedFormArray([]);

    courseItem.forEach((courseItemObject, index) => {
      formArray.push(this.formBuilder.group({
        courseItemId: this.router.url.includes("/duplicateproduct") ? 0 : courseItemObject.courseItemId,
        courseId: courseItemObject.courseId,
        title: courseItemObject.title,
        type: courseItemObject.type,
        active: courseItemObject.active,
        freePreview: courseItemObject.freePreview,
        // value: courseItemObject.value,
        value: courseItemObject.type == '9' ? parseInt(courseItemObject.value) : courseItemObject.value,
        customField1: courseItemObject.customField1,
        customField2: courseItemObject.customField2,
        customField3: courseItemObject.customField3,
        customField4: courseItemObject.customField4,
        customField5: courseItemObject.customField5,
        customField6: courseItemObject.customField6,
        customField7: courseItemObject.customField7,
        customField8: courseItemObject.customField8,
        customField9: courseItemObject.customField9,
        customField10: courseItemObject.customField10,
        courseDuration: courseItemObject.courseDuration
      }));
    });

    return formArray;

  }


  addCourse() {
    (<UntypedFormArray>this.form.get('course')).push(
      this.initCourseArray()
    );
  }

  addCourseItem(type, index) {


    this.courseForm.reset();
    this.courseType = 'Add';

    this.primaryIndex = index;



    this.courseItemId = 0;

    this.courseId = 0;

    var arrayControl = this.form.get('course') as UntypedFormArray;;
    var item = arrayControl.at(this.primaryIndex);
    var arrayControl1 = item.get('courseItem') as UntypedFormArray;

    arrayControl1.push(this.CourseItem());

    this.secondaryIndex = arrayControl1.length - 1;

    console.log(this.secondaryIndex);


  }


  CourseItem(): UntypedFormGroup {
    return this._formBuilder.group({
      courseItemId: [0],
      courseId: [0],
      title: [''],
      type: [''],
      active: [''],
      freePreview: [''],
      value: [''],
      customField1: [''],
      customField2: [''],
      customField3: [''],
      customField4: [''],
      customField5: [''],
      customField6: [''],
      customField7: [''],
      customField8: [''],
      customField9: [''],
      customField10: [''],
      courseDuration: [0.0]
    });
  }

  removeOption(i) {
    (<UntypedFormArray>this.form.get('course')).removeAt(i);
  }





  saveCourseItem() {
    if (this.form.value.courseItem.length != 0) {
      if (this.form.value.courseItem[0].title == '') {
        const formArray = this.form.get('courseItem') as FormArray;
        formArray.removeAt(0);
      }
    }
    this.setProductItem();
    this.close();
  }

  courseExpanded: boolean[] = []; // Track expanded state for each course item

  toggleCourseItems(index) {

    this.courseExpanded[index] = !this.courseExpanded[index];
  }

  @ViewChild('coursePopup') coursePopup: TemplateRef<any>;
  addCourseItemPopup(type, index, courseId, courseItemId) {

    this.courseId = courseId;

    this.courseItemId = courseItemId;

    this.addCourseItem(type, index);
    console.log(this.form.value);

    this.courseIndex = index;


    this.openCourseItemPopup();

  }

  openCourseItemPopup() {

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(this.coursePopup, {
        disableClose: true,
        width: '900px',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }
    else {
      let dialogRef = this.dialog.open(this.coursePopup, {
        minWidth: '100vw', height: '100vh',
      });

      dialogRef.afterClosed().subscribe((result) => {


      });
    }
  }

  setCourseItem() {


    const courseDurationControl = this.courseForm.get('courseDuration');

    if (this.courseForm.value.type === 1 || this.courseForm.value.type === 8) {
      courseDurationControl.setValidators(Validators.required); // Set required validator
    } else {
      courseDurationControl.clearValidators(); // Remove all validators
    }

    courseDurationControl.updateValueAndValidity();

    if (this.courseForm.valid) {
      if ((this.courseForm.value.type != 1 || this.courseForm.value.type != 8)) {
        let size = this.primaryIndex;

        let arrayControl = this.form.get('course') as UntypedFormArray;;
        let item = arrayControl.at(size);
        let arrayControl1 = item.get('courseItem') as UntypedFormArray;

        let courseItem = arrayControl1.at(this.secondaryIndex);

        courseItem.get("title").setValue(this.courseForm.value.title);

        courseItem.get("active").setValue(this.courseForm.value.active);

        courseItem.get("type").setValue(this.courseForm.value.type);

        courseItem.get("customField1").setValue(this.courseForm.value.customField1);

        courseItem.get("customField2").setValue(this.courseForm.value.customField2);

        courseItem.get("courseItemId").setValue(this.courseItemId);

        courseItem.get("courseId").setValue(this.courseId);

        courseItem.get("courseId").setValue(this.courseForm.value.customField2);

        courseItem.get("value").setValue(this.courseForm.value.value);

        courseItem.get("courseDuration").setValue(this.courseForm.value.courseDuration);

        courseItem.get("freePreview").setValue(this.courseForm.value.freePreview);

        this.close();

      }
    } else {
      this.courseForm.markAllAsTouched();
    }

  }


  removeCourseItem(primarayIndex: any, secondaryIndex: any) {
    let arrayControl = this.form.get('course') as UntypedFormArray;;
    let item = arrayControl.at(primarayIndex);
    let arrayControl1 = item.get('courseItem') as UntypedFormArray;
    arrayControl1.removeAt(secondaryIndex);
    console.log(this.form);
  }

  editCourseItem(courseItemObject, primarayIndex, secondaryIndex) {


    this.courseType = 'Edit';
    this.primaryIndex = primarayIndex;
    this.secondaryIndex = secondaryIndex;

    console.log(courseItemObject);

    this.courseId = courseItemObject.courseId

    this.courseItemId = courseItemObject.courseItemId

    this.courseForm.get("title").setValue(courseItemObject.title);

    this.courseForm.get("active").setValue(courseItemObject.active);

    this.courseForm.get("type").setValue(courseItemObject.type);

    this.courseForm.get("customField1").setValue(courseItemObject.customField1);

    this.courseForm.get("customField2").setValue(courseItemObject.customField2);

    this.courseForm.get("courseItemId").setValue(this.courseItemId);

    this.courseForm.get("courseId").setValue(this.courseId);

    this.courseForm.get('value').setValue(courseItemObject.value);

    this.courseForm.get('freePreview').setValue(courseItemObject.freePreview);

    this.courseForm.get('courseDuration').setValue(courseItemObject.courseDuration == null ? 0 : courseItemObject.courseDuration);

    this.openCourseItemPopup();

  }

  courseTypeDuration: any = 2;
  createCourseForm() {
    this.courseForm = this.formBuilder.group({
      courseItemId: [0],
      courseId: [0],
      title: ['', Validators.required],
      type: [2],
      active: [''],
      freePreview: [''],
      value: [''],
      customField1: [''],
      customField2: [''],
      customField3: [''],
      customField4: [''],
      customField5: [''],
      customField6: [''],
      customField7: [''],
      customField8: [''],
      customField9: [''],
      customField10: [''],
      courseDuration: [0.0],

    });
  }


  fileType: any = [
    { "value": 1, "viewValue": "Video" },
    { "value": 2, "viewValue": "Pdf" },
    { "value": 3, "viewValue": "Image" },
    // { "value": 4, "viewValue": "Zip" },
    // { "value": 5, "viewValue": "TextFile" },
    { "value": 6, "viewValue": "Url" },
    { "value": 7, "viewValue": "Text" },
    { "value": 8, "viewValue": "Audio" },
    { "value": 9, "viewValue": "Quiz" },
  ]




  getValue(event) {

    console.log(event);


    this.courseForm.get('value').setValue(event);

  }

  openEditorText(value) {



    if (window.innerWidth > 768) {

      const dialogRef = this.dialog.open(TextEditorComponent, {
        width: '900px',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getValue(result['data'])
        }


      });

    }
    else {
      const dialogRef = this.dialog.open(TextEditorComponent, {
        minWidth: '100vw', height: '100vh',
        disableClose: true,
        data: value
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {

          this.getValue(result['data'])
        }

      });

    }
  }
  setCourseType(value) {

    this.courseTypeDuration = value;
  }

  //  etLeadById(pk: number) {
  //     this.productlistingService.getProductlistingById(pk)
  //       .subscribe(
  //         (Productlisting: any) =>

  //           this.editProductlisting(Productlisting),

  //         (err: any) => { }
  //       );
  //   } 

  getLeadById(pk: number) {
    this.productlistingService.getProductlistingById(pk)
      .subscribe((Productlisting: any) => {

        let product: Product;
        if (Productlisting.value != undefined) {
          if (Productlisting.value.length > 0) {
            product = JSON.parse(Productlisting.value);
          }
        }
        this.editProductlisting(product)
      });


  }


  editProductlisting(product: Product) {

    this.productData = product;

    this.firstFormGroup.value.typeId = product.typeId;
    let products = product;
    this.initalValue = product['name'];
    this.skuInitalValue = product['sku'];
    this.valueId = product.valueIds;
    this.series.forEach(element => {
      let frontendLabel = element.attributeCode

      if (element.frontendInput == 'multiselect' && products[frontendLabel] != null) {

        let listOfOptions: any = [];
        products[frontendLabel].split(',').forEach(element => {
          listOfOptions.push(parseInt(element))
        });
        this.form.patchValue({
          [frontendLabel]: listOfOptions
        });
      }
      else if (element.backendType == 'datetime') {
        if (products[frontendLabel] != undefined) {
          this.form.patchValue({
            [frontendLabel]: new Date(products[frontendLabel]),
          });
        }
      } else {
        this.form.patchValue({
          [frontendLabel]: products[frontendLabel]
        });
      }
    });

    // this.form.setControl('catalogCategoryProduct', this.editCategory(product.catalogCategoryProduct));
    // this.form.setControl('catalogProductLink', this.editCatalogProductLink(product.catalogProductLink));
    // if (this.productId > 0) {
    //   this.mediaGallery = product.productEntityMediaGallery;
    // }

    // console.log(this.form.value);


  }


  //contact form

  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;

  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  dynamicFormList: any;
  getdynamicFormList() {
    this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
      (res) => {
        this.dynamicFormList = res;
        this.dynamicFormTypeList = this.dynamicFormList;
        this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
      },
      (error) => { }
    );
  }

  dynmaicFormYFilter() {
    this.dynamicFormFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.dynamicFilter();
      });
  }

  protected dynamicFilter() {
    if (!this.dynamicFormTypeList) {
      return;
    }
    let search = this.dynamicFormFilterControl.value;
    if (!search) {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter(
      (dynamicForm) => dynamicForm['name'].toLowerCase().indexOf(search) > -1
    );
  }

  getAlldynamicForm() {
    this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
  }

  getdynamicForm() {
    this.getdynamicFormList();
    this.dynmaicFormYFilter();
    this.getAlldynamicForm();
  }

  onFormSubmitted(event) {

    console.log(event);

  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
